import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ELEMENT_IDS, STYLES } from '../consts';
import Button from '../../../generic-components/Button';
import { ReactComponent as ClearIcon } from '../../../assets/icons/svg/shared/ic-shared-clear.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/svg/inline-error.svg';

interface IProps {
    item: any;
    control: any;
    getValues: any;
    setFocus: any;
    focusInputType:string;
    setValue: any;
    errors: any;
    trigger: any;
    setFocusInputType: any;
    setError: any;
    shouldHideField?: boolean;
}
export const RenderTextFiled = ({
  item, control, getValues, setFocus, focusInputType, setValue, errors, trigger, setFocusInputType, setError, shouldHideField,
}: IProps) => {
  const { t } = useTranslation();

  const formatUsPhone = (value: string) => value
    .replace(/^(\d{0,3})(\d{0,3})(\d{0,4})$/, (match, p1, p2, p3) => {
      let formatted = '';
      if (p1) formatted += `+1 (${p1}`;
      if (p2) formatted += `) ${p2}`;
      if (p3) formatted += `-${p3}`;
      return formatted;
    });

  return (
    <div className={`${shouldHideField ? 'hidden' : ''} fadeIn basis-1/2`} id={ELEMENT_IDS.LABEL_CONTROLLER_WRAPPER}>
      <Controller
        name={item.inputId}
        control={control}
        rules={{
          required: item.requiredMessage,
          validate: (value) => {
            if (item.requiredMessage) {
              return new RegExp(item.validateScheme).test(value) || item.validateErrorMessage;
            } if (!item.requiredMessage && getValues(item.inputId)) {
              return new RegExp(item.validateScheme).test(value) || item.validateErrorMessage;
            }
            return true;
          },
        }}
        render={({ field }) => (
          <>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
            <label
              onClick={() => setFocus(item.inputId)}
              className={`${field.value || focusInputType === item.inputId ? 'activeLabel' : ''}`}
              htmlFor={item.inputId}
              id={`elLabel-${item.inputId}`}
            >
              {t(item.name, item.name)}
            </label>
            {field.value && !item.disableClearButton && (
              <Button
                onClick={() => setValue(item.inputId, '', { shouldValidate: item.shouldValidateOnClick })}
                className={`hover:opacity-100 ${focusInputType === item.inputId ? 'opacity-100 fadeIn' : 'opacity-0'} ${STYLES.INPUT_CLEAR_BUTTON}`}
                id={`clear-${item.inputId}`}
                childElement={<ClearIcon className={STYLES.INPUT_CLEAR_BUTTON_CHILD} />}
              />
            )}
            <input
              type={item.inputType}
              maxLength={item.maxLen || ''}
              className={`w-full ${errors[item.inputId]?.message ? 'errorState' : ''} ${item?.specificType === 'number' ? 'tracking-[1.2px]' : 'tracking-[-0.15px]'} pr-[40px]`}
              {...field}
              placeholder=''
              disabled={item.disabled}
              id={`elInput-${item.inputId}`}
              onChange={(e) => {
                if (item.replaceValueScheme) {
                  field.onChange(e.target.value.replace(item.replaceValueScheme, ''));
                } else if (item.maskType) {
                  if (item.maskType === 'PHONE') {
                    const cleanValue = e.target.value.replace('+1', '').replace(/\D/g, '');
                    field.onChange(formatUsPhone(cleanValue));
                  }
                } else {
                  field.onChange(e.target.value.trimStart());
                }
                if (item.requiredMessage && e.target.value && !item.shouldAvoidValidateOnChange) {
                  setTimeout(() => {
                    trigger(item.inputId);
                  }, 0);
                }
              }}
              onBlur={() => {
                trigger(item.inputId);
                setFocusInputType('');
                setError(item.inputId, '');
              }}
              onFocus={() => {
                setFocusInputType(item.inputId);
              }}
            />
          </>
        )}
      />
      {errors[item.inputId]?.message && (
      <div className='errorWrapper flex items-center gap-[4px]'>
        <ErrorIcon />
        <p className='fadeIn' id={`${ELEMENT_IDS.INPUT_ERROR}-${item.inputId}`}>{t(errors[item.inputId]?.message)}</p>
      </div>
      )}
    </div>
  );
};
